import React, { useState, useRef } from "react";
import { toast } from "react-toastify";
import { validatePhoneNumber } from "../utils/metaData";

export const ConnectForm = () => {
  const formRef = useRef();
  const [formData, setFormData] = useState({
    name: '',
    phone: '',
    email: '',
    pickup: '',
    drop: ''
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!formData.name || !formData.phone || !formData.email || !formData.pickup || !formData.drop) {
      toast.error("All fields are required.");
      return;
    }

    if (!validatePhoneNumber(formData.phone)) {
      toast.error("Invalid Phone Number");
      return;
    }

    try {
      const { default: emailjs } = await import("@emailjs/browser");

      await emailjs.send(
        "service_e3p04st",
        "template_0xy8pfo",
        formData,
        "zFkMtBxuoxkPv2Yf1"
      );

      toast.success("✅ Your booking request has been sent!");
      setFormData({ name: '', phone: '', email: '', pickup: '', drop: '' });

    } catch (err) {
      console.error(err);
      toast.error("❌ Failed to send. Please try again.");
    }
  };

  return (
    <div className="w-full mt-8 md:mt-0 bg-black bg-opacity-50 backdrop-blur-md p-6 rounded-lg shadow-lg text-white flex flex-col items-center justify-center">
      <h2 className="text-xl font-semibold text-center mb-4 text-white">
        Book Your Ride
      </h2>
      <form ref={formRef} onSubmit={handleSubmit} className="w-full max-w-md">
        {["name","phone","email","pickup","drop"].map((field) => (
          <div className="mb-4" key={field}>
            <input
              type={field === "email" ? "email" : "text"}
              name={field}
              value={formData[field]}
              onChange={handleChange}
              className="w-full p-2 border border-gray-300 rounded-lg bg-transparent placeholder-white text-white"
              placeholder={
                field === "pickup" ? "Pickup Location" : 
                field === "drop" ? "Drop Location" : 
                field.charAt(0).toUpperCase() + field.slice(1)
              }
              required
            />
          </div>
        ))}

        <button
          type="submit"
          className="w-full bg-pink-600 text-white py-2 rounded-lg hover:bg-pink-500 transition"
        >
          Submit
        </button>
      </form>
    </div>
  );
};
